/*============Popup Controller
  ================================*/
  angular
    .module('vppApp')
    .controller('PopupController', PopupController);
// agregar SummaryGeneralFactory  - Account service
  PopupController.$inject = ['$scope', '$rootScope', '$location', '$http','$timeout', '$state'];

  function PopupController($scope, $rootScope, $location, $http, $timeout, $state){
    // var classHide = 'display-none';
    var modelInfo = {};
    // $rootScope.isAuth = AccountService.isUserLoggedIn();
    // $scope.cardType = AccountService.loadCardType();
    // angular.element(document).ready(function () {
    //   $timeout(function(){
    //     if($rootScope.isAuth){
    //       $rootScope.loadLoggedUrl();
    //     }
    //   });
    // });

    // $scope.hideModal = function(){
    //   $scope.$emit('popupHideEvent');
    //   $route.reload();
    //   body[0].style['overflow'] = "auto"; //this is for enable de scroll when the popup hides.
    //   document.getElementsByClassName('ng-modal-close')[0].style.color = "";
    // }









    // $scope.dialogTab = function(){

      //reset focus if popup has been opened before

      $scope.firstPopup = false;

      // document.onkeydown = function(evt) {
      //   // var dialogParent = document.getElementsByClassName('ng-modal-dialog')[0];
      //   // var dialog = dialogParent.children[0];

      //   var close = document.getElementsByClassName('ng-modal-close')[0];
      //   var tabKey = 9;

      //   // Handles the keyboard events for accessibility reasons
      //   if (evt) {
      //     $scope.modalFirstTime = false;
      //     var node = evt.target; // get the target node of the keypress event
      //     if (evt.keyCode === tabKey) {
      //       // find the first and last tab focusable items in the hierarchy of the dialog container node
      //       // do this every time if the items may be added / removed from the the dialog may change visibility or state
      //       var focusItemsArray = dialog.children;
      //       dialog.firstFocusItem = focusItemsArray[0];
      //       if(close !== undefined) {
      //         dialog.lastFocusItem = close;
      //       }
      //       else {
      //         dialog.lastFocusItem = focusItemsArray[focusItemsArray.length -1];
      //       }

      //       // if modal has only one interactive element
      //       if(focusItemsArray[0].id === 'simple-popup'){
      //         var singleFocusItem = focusItemsArray[focusItemsArray.length - 1];
      //         singleFocusItem.focus();
      //       }
      //     }
      //     // assumes firstFocusItem and lastFocusItem maintained by dialog object
      //     var singleFocusItem = (dialog.firstFocusItem == dialog.lastFocusItem);

      //     // see if we are shift-tabbing from first focusable item on dialog
      //     if (node == dialog.firstFocusItem && evt.shiftKey && evt.keyCode === tabKey) {
      //       if (!singleFocusItem) {
      //           dialog.lastFocusItem.focus(); // send focus to last item in dialog
      //       }
      //     }
      //     // see if we are tabbing from the last focusable item
      //     else if (node == dialog.lastFocusItem && evt.keyCode === tabKey) {
      //       if (!singleFocusItem) {
      //         dialog.firstFocusItem.focus(); // send focus to first item in dialog
      //       }
      //     }
      //   }
      // } // end of function
    //}

  };
